import { formatIndianNumberWithDecimals } from "../../utils/FD/fd";

export default function RebalanceHeaderForRegularToDirectPlan({ headingValue }: { headingValue: number }) {
  return (
    <div className='mb-8'>
      <div className='text-grey40 text-xl'>
        Switch your <span className='text-black'>{headingValue > 0 ? `₹${formatIndianNumberWithDecimals(headingValue,0)}` : ''} lump-sum </span>
        <br /> and <span className='text-black'>current SIP (if any)</span> to its <br />
        Direct Plan
      </div>
    </div>
  )
}
